import { useNavigate } from '@tanstack/react-router';
import type { MouseEvent } from 'react';

/** Router navigation on a plain click, the browser's own on Ctrl/Cmd-click
 *  (for links drawn as buttons with an href). */
export function useRouterClick() {
  const navigate = useNavigate();
  return (to: string) => (e: MouseEvent<HTMLElement>) => {
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    e.preventDefault();
    void navigate({ to });
  };
}
